import { Injectable } from '@angular/core';
import { EpisodePaginationModel } from 'qp-ui-interface';
import { StorefrontService } from '../../../storefront/storefront.service';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  constructor(private readonly storefrontService: StorefrontService) {}

  async episodesPagination(
    seriesId: string,
    seasonId: string,
    path: string,
    episodesPath: string,
    episodesPageNumber: string,
    episodesPageSize: string,
    seasonNumber: string,
    sortOrder: string
  ): Promise<EpisodePaginationModel> {
    const episodesData = {
      seriesPath: path,
      episodesPath,
      seasonNumber,
      episodesSort: sortOrder,
    };
    let title = '';
    try {
      const cantainerVm = await this.storefrontService.fetchEpisodes(
        seriesId,
        seasonId,
        episodesPageNumber,
        episodesPageSize,
        episodesData
      );
      const episodesResources = cantainerVm.resources;
      if (episodesResources.length > 0) {
        title = `Season ${seasonNumber}, ${episodesResources.length} Episodes`;
      }
      return {
        episodes: episodesResources,
        seasonNumber: parseInt(seasonNumber, 10),
        title,
      };
    } catch (e) {
      return {
        episodes: [],
        seasonNumber: parseInt(seasonNumber, 10),
        title,
      };
    }
  }
}
